import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { getLocalText } from '@/utilities/language';
var defaultAnswer = {
  date: undefined,
  type: 'date'
};
var DateChoice = /*#__PURE__*/function (_React$Component) {
  _inherits(DateChoice, _React$Component);
  function DateChoice() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, DateChoice);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DateChoice)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "validator", function (_rules, answer, callback) {
      var question = _this.props.question;
      if (question.required && !answer.date) {
        callback(getLocalText('SingleChoice.Selected'));
      }
      callback();
    });
    return _this;
  }
  _createClass(DateChoice, [{
    key: "getDateChange",
    value: function getDateChange(date) {
      return {
        date: "".concat(date),
        type: 'date'
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        question = _this$props.question,
        _this$props$answer = _this$props.answer,
        answer = _this$props$answer === void 0 ? JSON.parse(JSON.stringify(defaultAnswer)) : _this$props$answer;
      var _this$props$form = this.props.form,
        getFieldProps = _this$props$form.getFieldProps,
        getFieldError = _this$props$form.getFieldError;
      var id = question.id || 'unknown-form-item';
      var _getFieldProps = getFieldProps(id, {
          initialValue: _objectSpread({}, answer),
          rules: [{
            validator: this.validator
          }]
        }),
        _onChange = _getFieldProps.onChange,
        formAnswer = _getFieldProps.value;
      var error = getFieldError(id);
      if (error && error.length > 0) error = error.join(',');else error = null;
      var params = {
        error: error,
        formAnswer: formAnswer,
        onChange: function onChange(val) {
          return _onChange(_this2.getDateChange(val));
        }
      };
      return this.props.children(params);
    }
  }]);
  return DateChoice;
}(React.Component);
export { DateChoice as default };